//local imports
import classes from "@/styles/how-it-works/how-it-works-main.module.css";
import { howItWorksPage } from "@/utils/content";
import { woImg1 } from "@/utils/images";
import Image from "next/image";
import { Card, CardBody } from "reactstrap";

export default function HowItWorksMain() {
  const content = howItWorksPage.en;

  return (
    <div className={classes.container}>
      <div className="container">
        <h1 className="text-center text-secondary my-5">{content.title}</h1>
        {content.list?.map((l, i) => {
          return (
            <Card key={i} className="my-3">
              <CardBody className="p-5">
                <h3 className="text-secondary">
                  {i + 1}. {l.title}
                </h3>
                <p className="ms-4">{l.para}</p>
                <Image
                  src={l.img}
                  alt={l.img}
                  className="img-fluid"
                  height={1000}
                  width={1000}
                />
              </CardBody>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
